import VirtualStagingCard from './virtual-staging-card'
export default VirtualStagingCard
